<template>
  <CockpitDialog
    title="应急物资详情"
    @close="() => $emit('close')"
    left="530px"
    width="890px"
    height="550px"
    top="160px"
  >
    <div class="h-full pr-10px w-full overflow-auto">
      <categoryTitle class="my-20px" title="物资信息" />
      <el-form
        :model="inforFormData"
        ref="inforFormDataRef"
        label-width="110px"
        disabled
        label-suffix=" :"
      >
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('物资编码')}`">
              <!-- <div class="cus-content">{{ inforFormData.codeStr }}</div> -->
              <el-input size="small" v-model="inforFormData.codeStr" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('物资名称')}`">
              <el-input size="small" v-model="inforFormData.name" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('责任部门')}`">
              <el-input size="small" v-model="inforFormData.orgName" />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('出厂编号')}`" prop="factoryCode">
              <el-input size="small" v-model="inforFormData.no" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('出厂日期')}`">
              <el-date-picker
                style="width:100%"
                v-model="inforFormData.productionDate"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('有效期')}`">
              <el-date-picker
                v-model="inforFormData.expirationDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('物资点位')}`">
              <el-input size="small" v-model="inforFormData.suppliesSiteName" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('检验责任人')}`">
              <el-input size="small" v-model="inforFormData.responsiblePersonName" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('初次检验日期')}`" prop="firstInspectionDate">
              <el-date-picker
                v-model="inforFormData.initialInspectionDate"
                type="date"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                style="width:100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <categoryTitle class="mb-20px" title="物资类型信息" />
      <el-form
        :model="categoryFormData"
        ref="categoryFormRef"
        label-width="110px"
        disabled
        label-suffix=" :"
      >
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('物资类型名称')}`">
              <el-input size="small" v-model="categoryFormData.name" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('物资类别')}`">
              <el-input size="small" v-model="categoryFormData.suppliesCategoryStr" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('规格型号')}`">
              <el-input size="small" v-model="categoryFormData.no" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('生产厂家')}`" prop="manufacturer">
              <el-input size="small" v-model="categoryFormData.manufacturer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="`${$t('用途说明')}`" prop="useDescription">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                size="small"
                v-model="categoryFormData.useTo"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="`${$t('性能说明')}`" prop="performanceDescription">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                size="small"
                v-model="categoryFormData.specifications"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('物资图片')}`">
              <div v-if="categoryFormData.picture">
                <div v-for="(item, index) in categoryFormData.picture.split(',')" :key="index">
                  <a
                    style="color:#44F1FF"
                    @click="downLoadFile(item, categoryFormData.pictureName.split(',')[index])"
                    >{{ categoryFormData.pictureName.split(',')[index] }}
                  </a>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('说明书')}`">
              <div v-if="categoryFormData.instructions">
                <div v-for="(item, index) in categoryFormData.instructions.split(',')" :key="index">
                  <a
                    style="color:#44F1FF"
                    @click="downLoadFile(item, categoryFormData.instructionsName.split(',')[index])"
                    >{{ categoryFormData.instructionsName.split(',')[index] }}
                  </a>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('检验报告')}`">
              <div v-if="categoryFormData.report">
                <div v-for="(item, index) in categoryFormData.report.split(',')" :key="index">
                  <a
                    style="color:#44F1FF"
                    @click="downLoadFile(item, categoryFormData.reportName.split(',')[index])"
                    >{{ categoryFormData.reportName.split(',')[index] }}
                  </a>
                </div>
              </div>
            </el-form-item>
          </el-col></el-row
        >
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              :label="`${$t('合格证')}`"
              prop="certificateFiles"
              ref="certificateFilesRef"
            >
              <div v-if="categoryFormData.certificate">
                <div v-for="(item, index) in categoryFormData.certificate.split(',')" :key="index">
                  <a
                    style="color:#44F1FF"
                    @click="downLoadFile(item, categoryFormData.certificateName.split(',')[index])"
                    >{{ categoryFormData.certificateName.split(',')[index] }}
                  </a>
                </div>
              </div>
            </el-form-item>
          </el-col></el-row
        >
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item :label="`${$t('定期检验')}`" prop="inspection" :validate-event="false">
              <el-switch v-model="categoryFormData.isPeriodic"> </el-switch>
            </el-form-item> </el-col
        ></el-row> -->
        <el-row v-if="categoryFormData.isPeriodic">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('检验单周期')}`" prop="inspectionCycle">
              <div class="flex items-center">
                <el-input-number
                  size="small"
                  type="number"
                  v-model="categoryFormData.cycle"
                  :controls="false"
                ></el-input-number>
                <el-input size="small" v-model="categoryFormData.unit" class="ml-10px" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('检验提醒时间')}`" prop="inspectionDate">
              <el-input-number
                size="small"
                type="number"
                v-model="categoryFormData.remind"
                step-strictly
                :controls="false"
              ></el-input-number
              ><span class="ml-10px text-[#fff]">天</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <categoryTitle class="mb-10px" title="检验信息" />
      <el-form
        :model="inspectionInforFormData"
        ref="inspectionInforRef"
        label-width="110px"
        disabled
        label-suffix=" :"
      >
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('检验开始时间')}`" prop="startDate">
              <el-date-picker
                v-model="inspectionInforFormData.startDate"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('检验截止时间')}`" prop="endDate">
              <el-date-picker
                v-model="inspectionInforFormData.endDate"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              :label="`${$t('检验时间')}`"
              prop="inspectionTime"
              v-if="inspectionInforFormData.status === 1"
            >
              <el-date-picker
                v-model="inspectionInforFormData.inspectionTime"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="inspectionInforFormData.status === 1">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('检验人')}`" prop="inspector">
              <el-input
                size="small"
                maxlength="50"
                :placeholder="`${$t('请输入')}`"
                v-model="inspectionInforFormData.inspector"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item :label="`${$t('检验结果')}`" prop="isPass">
              <p>{{ inspectionInforFormData.isPass ? '通过' : '不通过' }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="inspectionInforFormData.status === 1">
          <el-col :span="24">
            <el-form-item :label="`${$t('检验说明')}`" prop="summary">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                v-model="inspectionInforFormData.summary"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="inspectionInforFormData.status === 1">
          <el-col :span="24">
            <el-form-item :label="`${$t('检验记录文件')}`" prop="file">
              <div v-for="(item, index) in inspectionInforFormData.files" :key="index">
                <a @click="downLoadFile(item.id, item.fileName)" style="color:#44F1FF">{{
                  item.fileName
                }}</a>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </CockpitDialog>
</template>

<script>
// components
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import {
  SuppliesTypeApi,
  SuppliesManagementApi,
  SuppliesInspectionApi,
} from '@wiz-api/emergency-management'
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
const suppliesInspectionApi = new SuppliesInspectionApi()
const suppliesManagementApi = new SuppliesManagementApi()
export default {
  components: { CockpitDialog, CategoryTitle },
  data() {
    return {
      inforFormData: {
        factoryCode: '',
        name: '',
        code: '',
        firstInspectionDate: '',
        userIds: '',
        materialPoint: '',
        expirationDate: '',
        factoryDate: '',
        dutyDepartment: '',
      }, // 表单数据
      categoryFormData: {
        name: '',
        category: '',
        inspection: true,
        inspectionCycle: 1,
        inspectionCycleUnit: '',
        inspectionDate: 1,
        certificateFiles: '',
        materielPicturesFiles: '',
        inspectionReportFiles: '',
        instructionsFiles: '',
        performanceDescription: '',
        useDescription: '',
        manufacturer: '',
        specificationsModels: '',
      },
      inspectShow: false,
      inspectionInforFormData: {
        startDate: '',
        endDate: '',
        inspectionTime: '',
        inspector: '',
        isPass: '',
        summary: '',
        files: [],
      },
    }
  },
  methods: {
    // 附件，下载
    async downLoadFile(id, name) {
      const [err, res] = await fileApi.download(id, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res, name)
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: '下载成功!',
      })
    },
    async getDetail(id) {
      const [err, res] = await suppliesManagementApi.getDataInfo({ id })
      if (!err) {
        this.inforFormData = res.data
        this.categoryFormData = res.type
      }
    },
    getInspect() {},
    // 获取检测物资
    async getList() {
      const params = {
        skipCount: 0,
        maxResultCount: 15,
        keywords: this.listInfo.codeStr,
      }
      const [err, data] = await suppliesInspectionApi.getList(params)
      if (!err) {
        if (data.items.length) {
          this.inspectionInforFormData = data.items[0]
          this.inspectionInforFormData.files = JSON.parse(
            this.inspectionInforFormData.files || '[]'
          )
          this.inspectShow = true
        } else {
          this.inspectShow = false
        }
      }
    },
  },
  async created() {},

  props: {
    listInfo: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    'listInfo.id': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getList()
          this.getDetail(newVal)
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.tree-wrap {
  border: 1px solid #45f2eb33;
  background-color: #184c5c4c;
}
.table-wrap {
  border-left: 1px solid #2f7075;
}
::v-deep .el-form-item__label {
  color: #fff;
}
</style>
